import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TransactionGreen, TransactionHistory, TransactionRed } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import { formatMoney } from '../../../utils/formatMoney'
import './myWallet.css'

// "Add Money" and "Rewards" have no backing API/flow yet — only Transaction
// History is real, so that's the only quick action kept live.
const QUICK_ACTIONS = [
    { icon: TransactionHistory, title: 'Transaction History', subtitle: 'Check All Transactions', path: '/my-transaction' },
]

const WALLET_BENEFITS = [
    'Get 2% cashback on every wallet transaction',
    'Earn reward points with every booking',
    'Instant refunds directly to wallet',
    'Priority customer support for wallet users',
]

// Confirmed live: `wallet_amount` and `amount` are the same numeric string
// ("17729.00"); `balance` is a pre-comma-formatted display string with no
// currency symbol ("17,729.00"). `wallet_amount` is the one to format.
const isDebitTxn = (txn) => txn.direction === 'out' || txn.type === 'debit' || txn.txn_type === 'debit' || txn.amount_tone === 'negative'

const TxnRow = ({ txn }) => {
    const debit = isDebitTxn(txn)
    return (
        <div className='walletTxnRow'>
            <span className={`walletTxnRow__icon ${debit ? 'walletTxnRow__icon--debit' : ''}`}>
                <img src={debit ? TransactionRed : TransactionGreen} alt="" />
            </span>
            <div className='walletTxnRow__info'>
                <div className='walletTxnRow__title'>{txn.title || txn.description || 'Transaction'}</div>
                <div className='walletTxnRow__date'>{txn.date_label || ''}</div>
            </div>
            {/* `signed_amount` already comes pre-formatted with sign + ₹, e.g. "+₹500.00" */}
            <span className={`walletTxnRow__amount ${debit ? 'walletTxnRow__amount--debit' : ''}`}>
                {txn.signed_amount || formatMoney(txn.amount, txn.currency)}
            </span>
        </div>
    )
}

const MyWallet = () => {
    const navigate = useNavigate()
    const [balance, setBalance] = useState(null)
    const [currency, setCurrency] = useState('INR')
    const [transactions, setTransactions] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        service
            .get(endpoints.users.walletBalance, { include_transactions: true }, { silent: true })
            .then(({ data }) => {
                const payload = data?.data || {}
                setBalance(payload.wallet_amount)
                setCurrency(payload.currency || 'INR')
                setTransactions(Array.isArray(payload.recent_transactions) ? payload.recent_transactions : [])
            })
            .catch(() => {})
            .finally(() => setLoading(false))
    }, [])

    return (
        <div className='myWallet'>
            <div className='walletBalanceCard'>
                <div>
                    <div className='walletBalanceCard__label'>TOTAL BALANCE</div>
                    <div className='walletBalanceCard__value'>
                        {loading ? '...' : (balance != null ? formatMoney(balance, currency) : '—')}
                    </div>
                </div>
                {/* Reward points aren't part of the Wallet API response yet —
                    no field for it. Re-enable once the backend adds one. */}
                {/* <div className='walletBalanceCard__rewards'>
                    <img src={RewardPoints} alt="" />
                    <div>
                        <div className='walletBalanceCard__label'>Rewards Points</div>
                        <div className='walletBalanceCard__rewardsValue'>{WALLET.rewardPoints}</div>
                    </div>
                </div> */}
            </div>

            <div className='bsSectionTitle mt-4'>Quick Actions</div>
            <div className='walletQuickActions'>
                {QUICK_ACTIONS.map((action, index) => (
                    <div
                        className='walletQuickAction bgWhite commonBorder borderRadius20'
                        key={index}
                        onClick={action.path ? () => navigate(action.path) : undefined}
                    >
                        <img src={action.icon} alt="" />
                        <div className='walletQuickAction__title'>{action.title}</div>
                        <div className='walletQuickAction__subtitle'>{action.subtitle}</div>
                    </div>
                ))}
            </div>

            {/* Linked Digital Wallets (Apple Pay / Google Pay) — no
                wallet-linking API exists yet. Re-enable once one does. */}
            {/* <div className='bsSectionTitle mt-4'>Linked Digital Wallets</div>
            <div className='walletLinkedRow'>
                {LINKED_WALLETS.map((wallet, index) => (
                    <div className='walletLinkedCard bgWhite commonBorder borderRadius20' key={index}>
                        <span className='resultCard__logo'>
                            <img src={wallet.icon} alt={wallet.name} />
                        </span>
                        <div className='walletLinkedCard__info'>
                            <div className='resultCard__airlineName'>{wallet.name}</div>
                            <div className='paymentSavedMethodSub'>{wallet.detail}</div>
                        </div>
                        <span className='travellerPassengerType'>Connected</span>
                    </div>
                ))}
            </div>
            <button type='button' className='travellerAddBtn' onClick={() => navigate('/add-money')}>Link New Wallet</button> */}

            <div className='bsSectionTitle mt-4'>Recent Transactions</div>
            <div className='walletTxnList bgWhite commonBorder borderRadius20 paddingCommon20'>
                {loading ? (
                    <p className='bsFareNote'>Loading...</p>
                ) : transactions.length ? transactions.map((txn, index) => (
                    <TxnRow txn={txn} key={txn.id ?? index} />
                )) : (
                    <p className='bsFareNote'>No transactions yet.</p>
                )}
            </div>
            <button type='button' className='travellerAddBtn' onClick={() => navigate('/my-transaction')}>View All</button>

            <div className='bsSectionTitle mt-4'>Wallet Benefits</div>
            <div className='bsBox'>
                <ul className='bsInfoList'>
                    {WALLET_BENEFITS.map((benefit, index) => (
                        <li key={index}>{benefit}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default MyWallet
